<template>
  <div class="card">
    <div class="card-content">
      <div class="row">
        <div class="col-xs-5">
          <slot name="header" />
        </div>
        <div class="col-xs-7">
          <slot name="content" />
        </div>
      </div>
    </div>
    <div class="card-footer">
      <hr>
      <slot name="footer" />
    </div>
  </div>
</template>
<script>
  export default {
    name: 'StatsCard'
  }

</script>
<style scoped>
  .card-content{
    min-height: 85px
  }
</style>
